import { useMutation } from '@tanstack/react-query'

import { type TAtendimentoEncerradoResponse } from '@/features/atendimento/interfaces'
import { EncerrarAtendimentoService } from '@/features/atendimento/services/encerrar-atendimento.service'
import { atendimentoKeys } from '@/features/atendimento/utils/queries'
import type { AxiosErrorMap } from '@/shared/lib/http/axios-adapter'

export const useEncerrarAtendimento = () => {
  return useMutation<TAtendimentoEncerradoResponse, AxiosErrorMap, string>({
    mutationKey: atendimentoKeys.encerrarAtendimento(),
    mutationFn: async (id: string) => new EncerrarAtendimentoService().execute(id),
  })
}
